"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useBreakPoint = require("../../../../common/useBreakPoint");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getImageSubtext = image => {
  return `${image.title} / ${image.copyright}`;
};
const Slide = _ref => {
  let {
    title,
    article_lead,
    pictures_gallery
  } = _ref;
  const {
    isDesktop,
    isTablet,
    isMobile
  } = (0, _useBreakPoint.useBreakPoint)();
  const src = pictures_gallery[0] && pictures_gallery[0][0]?.desktop?.url;
  const srcTablet = pictures_gallery[0] && pictures_gallery[0][0]?.tablet?.url;
  const srcMobile = pictures_gallery[0] && pictures_gallery[0][0]?.mobile?.url;
  const imageSubtext = pictures_gallery[0] && getImageSubtext(pictures_gallery[0][0]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "slide"
  }, src ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isDesktop && /*#__PURE__*/_react.default.createElement("img", {
    className: "slide-img",
    src: src
  }), isTablet && /*#__PURE__*/_react.default.createElement("img", {
    className: "slide-img",
    src: srcTablet || src
  }), isMobile && /*#__PURE__*/_react.default.createElement("img", {
    className: "slide-img",
    src: srcMobile || src
  }), imageSubtext && /*#__PURE__*/_react.default.createElement("p", {
    className: "imageSubtext sia-text-11"
  }, imageSubtext)) : /*#__PURE__*/_react.default.createElement("div", {
    className: "slide-img",
    src: src
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "text"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "sia-text-14 sia-padding-02-bottom",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }), /*#__PURE__*/_react.default.createElement("p", {
    className: "lead sia-text-10",
    dangerouslySetInnerHTML: {
      __html: article_lead[0]
    }
  })));
};
Slide.propTypes = {
  title: _propTypes.default.string.isRequired,
  top: _propTypes.default.string.isRequired,
  lead: _propTypes.default.string.isRequired,
  tag: _propTypes.default.string,
  src: _propTypes.default.string.isRequired,
  srcTablet: _propTypes.default.string,
  srcMobile: _propTypes.default.string
};
var _default = exports.default = Slide;